import AgreementResource from '../agreement'
import DepartmentResource from '../department'
import EntitiesResource from '../entities'
import FlsaResource from '../flsatype'
import JobTitleResource from '../jobTitle'
import LegislativeResource from '../legislativeType'
import ProjectLocationResource from '../projectLocation'
import RateUnitResource from '../rateUnit'
import UnionLocalResource from '../unionLocal'
import { DefaultInput, DefaultFormSelect, DefaultFormAutocomplete } from './index'

const assignmentStatusOptions = [
    { value: 0, text: 'Voided' },
    { value: 1, text: 'New' },
    { value: 2, text: 'Employee Notified (email sent)' },
    { value: 3, text: 'Employee Viewed' },
    { value: 4, text: 'Employee Approved' },
    { value: 5, text: 'Partially Approved (when multiple approvers are in play)' },
    { value: 6, text: 'Approved/Final (this is the final state for 99% of our employees)' },
    { value: 7, text: 'Termination Started' },
    { value: 8, text: 'Termination Confirmed (not really used)' },
]

export default {
    job_order: new DefaultInput('Job Order'),
    entity_id: new DefaultFormAutocomplete('Entity', EntitiesResource, 'entity_id'),
    employee_id: new DefaultInput('Employee'),
    location_id: new DefaultFormAutocomplete('Location', ProjectLocationResource, 'location_id'),
    job_title_id: new DefaultFormAutocomplete('Job Title', JobTitleResource, 'job_title_id'),
    start_date: new DefaultInput('Start Date'),
    term_date: new DefaultInput('Term Date'),
    flsa_type_id: new DefaultFormAutocomplete('Flsa Type', FlsaResource, 'flsa_type_id'),
    legislative_type_id: new DefaultFormAutocomplete('Legislative Type', LegislativeResource, 'legislative_type_id'),
    union_local_id: new DefaultFormAutocomplete('Union Local', UnionLocalResource, 'union_local_id'),
    agreement_id: new DefaultFormAutocomplete('Agreement', AgreementResource, 'agreement_id'),
    department_id: new DefaultFormAutocomplete('Department', DepartmentResource, 'department_id'),
    exemptions: new DefaultInput('Exemptions'),
    budget_code: new DefaultInput('Budget Code'),
    fringe_code: new DefaultInput('Fringe Code'),
    login_allowed: new DefaultInput('Login Allowed'),
    rate: new DefaultInput('Rate'),
    rate_unit_id: new DefaultFormAutocomplete('Rate Unit', RateUnitResource, 'rate_unit_id'),
    guaranteed_hours: new DefaultInput('Guaranteed Hours'),
    guaranteed_hours_unit_id: new DefaultInput('Guaranteed Hours Unit'),
    hourly_rate: new DefaultInput('Hourly Rate'),
    kit_rental: new DefaultInput('Kit Rental'),
    kr_code: new DefaultInput('Kit Rental Code'),
    per_diem: new DefaultInput('Per Diem'),
    pd_code: new DefaultInput('Per Diem Code'),
    mileage: new DefaultInput('Mileage'),
    mi_code: new DefaultInput('Mileage Code'),
    mileage_rate: new DefaultInput('Mileage Rate'),
    car_rental: new DefaultInput('Car Rental'),
    cr_code: new DefaultInput('Car Rental Code'),
    other: new DefaultInput('Other'),
    other_code: new DefaultInput('Other Code'),
    employee_comments: new DefaultInput('Employee Comments'),
    employer_comments: new DefaultInput('Employer Comments'),
    status: new DefaultFormSelect('Status', assignmentStatusOptions, 'status'),
    employee_status: new DefaultInput('Employee Status'),
    rule_collection_id: new DefaultInput('Rule Collection'),
    list_a_type_id: new DefaultInput('List_A Type'),
    list_a_number: new DefaultInput('List_A Number'),
    list_a_auth: new DefaultInput('list_a_auth'),
    list_a_exp: new DefaultInput('list_a_exp'),
    list_b_type_id: new DefaultInput('list_b_type'),
    list_b_number: new DefaultInput('list_b_number'),
    list_b_auth: new DefaultInput('list_b_auth'),
    list_b_exp: new DefaultInput('list_b_exp'),
    list_c_type_id: new DefaultInput('list_c_type'),
    list_c_number: new DefaultInput('list_c_number'),
    list_c_auth: new DefaultInput('list_c_auth'),
    list_c_exp: new DefaultInput('list_c_exp'),
    paper_form: new DefaultInput('Paper Form'),
    dd_status: new DefaultInput('Direct Deposit Status'),
    dd_bank_type_1: new DefaultInput('Direct Deposit Bank Type 1'),
    dd_bank_name_1: new DefaultInput('Direct Deposit Bank Name 1'),
    dd_bank_city_state_1: new DefaultInput('Direct Deposit Bank City State 1'),
    dd_bank_account_name_1: new DefaultInput('Direct Deposit Bank Account Name 1'),
    dd_bank_account_1: new DefaultInput('Direct Deposit Bank Account 1'),
    dd_bank_routing_1: new DefaultInput('Direct Deposit Bank Routing 1'),
    dd_bank_amount_1: new DefaultInput('Direct Deposit Bank Amount 1'),
    dd_bank_percent_1: new DefaultInput('Direct Deposit Bank Percent 1'),
    dd_bank_type_2: new DefaultInput('Direct Deposit Bank Type 2'),
    dd_bank_name_2: new DefaultInput('Direct Deposit Bank Name 2'),
    dd_bank_city_state_2: new DefaultInput('Direct Deposit Bank City State 2'),
    dd_bank_account_name_2: new DefaultInput('Direct Deposit Bank Account Name 2'),
    dd_bank_account_2: new DefaultInput('Direct Deposit Bank Account 2'),
    dd_bank_routing_2: new DefaultInput('Direct Deposit Bank Routing 2'),
    dd_bank_amount_2: new DefaultInput('Direct Deposit Bank Amount 2'),
    dd_bank_percent_2: new DefaultInput('Direct Deposit Bank Percent 2'),
    exemptions_state: new DefaultInput('Exemptions State'),
    country_id: new DefaultInput('Country Id'),
    i9_verifier_id: new DefaultInput('I9 Verifier Id'),
    i9_verified_date: new DefaultInput('I9 Verified Date'),
    is_rehire: new DefaultInput('Is Rehire'),
    occ_code: new DefaultInput('Occ Code'),
    union_location_id: new DefaultInput('Union Location'),
    union_ruleset_id: new DefaultInput('Union Ruleset'),
    union_hired_from_id: new DefaultInput('Union Hired From'),
    union_schedule_id: new DefaultInput('Union Schedule'),
    union_on_prod_id: new DefaultInput('Union On Prod'),
    union_flsa_type_id: new DefaultInput('Union Flsa Type'),
    recurring_comments: new DefaultInput('Recurring Comments'),
    kit_inventory_id: new DefaultInput('Kit Inventory'),
    sick_policy_id: new DefaultInput('Sick Policy'),
    free_field: new DefaultInput('Free Field'),
    kr_free_field: new DefaultInput('Kit Rental Free Field'),
    pdtax_free_field: new DefaultInput('Per Diem Taxable Free Field'),
    pdadv_free_field: new DefaultInput('Per Diem Advance Free Field'),
    cr_free_field: new DefaultInput('Car Rental Free Field'),
    agent_fee: new DefaultInput('Agent Fee'),
    agent_free_field: new DefaultInput('Agent Free Field'),
    pd_free_field: new DefaultInput('Per Diem Free Field'),
    union_dues_withholding_id: new DefaultInput('Union Dues Withholding'),
    other_free_field: new DefaultInput('Other Free Field'),
    resident_state_id: new DefaultInput('Resident State'),
    currency_id: new DefaultInput('Currency'),
    termination_comments: new DefaultInput('Termination Comments'),
    termination_forms: new DefaultInput('Termination Forms'),
    termination_form_fields: new DefaultInput('Termination Form Fields'),
    custom_form_employer_fields: new DefaultInput('Custom Form Employer Fields'),
    rate_comment: new DefaultInput('Rate Comment'),
    is_supervisor: new DefaultInput('Is Supervisor'),
    certification_type_id: new DefaultInput('Certification Type'),
    guaranteed_hours_6th: new DefaultInput('Guaranteed Hours 6th'),
    guaranteed_hours_7th: new DefaultInput('Guaranteed Hours 7th'),
    ee_list_a_number: new DefaultInput('ee_list_a_number'),
    ee_list_a_type_id: new DefaultInput('ee_list_a_type'),
    ee_list_a_auth: new DefaultInput('ee_list_a_auth'),
    ee_list_a_exp: new DefaultInput('ee_list_a_exp'),
    ee_list_b_type_id: new DefaultInput('ee_list_b_type'),
    ee_list_b_number: new DefaultInput('ee_list_b_number'),
    ee_list_b_auth: new DefaultInput('ee_list_b_auth'),
    ee_list_b_exp: new DefaultInput('ee_list_b_exp'),
    ee_list_c_type_id: new DefaultInput('ee_list_c_type'),
    ee_list_c_number: new DefaultInput('ee_list_c_number'),
    ee_list_c_auth: new DefaultInput('ee_list_c_auth'),
    ee_list_c_exp: new DefaultInput('ee_list_c_exp'),
    dd_bank_branch_1: new DefaultInput('Direct Deposit Bank Branch 1'),
    dd_bank_branch_2: new DefaultInput('Direct Deposit Bank Branch 2'),
    canada_form_fields: new DefaultInput('Canada Form Fields'),
    per_diem_taxable: new DefaultInput('Per Diem Taxable'),
    pd_taxable_code: new DefaultInput('Per Diem Taxable Code'),
    series_code: new DefaultInput('Series Code'),
    location_code: new DefaultInput('Location Code'),
    set_code: new DefaultInput('Set Code'),
    per_diem_advance: new DefaultInput('Per Diem Advance'),
    pd_advance_code: new DefaultInput('Per Diem Advance Code'),
    propay_id: new DefaultInput('Propay Id'),
    fed_jobcategory_id: new DefaultInput('Fed Jobcategory'),
    ca_jobcategory_id: new DefaultInput('Ca Jobcategory'),
    scale_rate: new DefaultInput('Scale Rate'),
    scale_stn: new DefaultInput('Scale Stn'),
    free_field2: new DefaultInput('Free Field 2'),
    kr_free_field2: new DefaultInput('Kit Rental Free Field 2'),
    pd_free_field2: new DefaultInput('Per Diem Free Field 2'),
    pdtax_free_field2: new DefaultInput('Per Diem Taxable Free Field 2'),
    pdadv_free_field2: new DefaultInput('Per Diem Advance Free Field 2'),
    cr_free_field2: new DefaultInput('Car Rental Free Field 2'),
    mi_free_field2: new DefaultInput('Mileage Free Field 2'),
    other_free_field2: new DefaultInput('Other Free Field 2'),
    agent_free_field2: new DefaultInput('Agent Free Field 2'),
}

export { assignmentStatusOptions }
